// extracted by mini-css-extract-plugin
export var dataCell = "_qx-2";
export var dataRow = "_qx-0";
export var headerRow = "_qx-1";